// extracted by mini-css-extract-plugin
export var notificationHost = "_kk-0";